export default __webpack_public_path__ + "static/media/OUR HISTORY.baa84027.jpg";